import React from "react";
import Form from "./components/Form";

const CreateNotaDebito = () => {

    return (
        <Form />
    );
};

export default CreateNotaDebito;